import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGlobalPopUpWrapper } from '../reducer';
import './InformayionScreenWrapper.scss';

import { clearGlobalPopUpWrapper } from '../actions';
import ViolationControlWorkDetailsPopUp from './ViolationControlWorkDetailsPopUp';
import { POPUP_LIST_NAME } from '../../../configs';
import InformationPopUp from './InformationPopUp';
import ViolationDetailsPopUp from './ViolationDetailsPopUp';
import RepresentativeDetailsPopUp from './RepresentativeDetailsPopUp';

export const POPUP_LIST = {
  // [POPUP_LIST_NAME.VISIT_DETAIL]: VisitDetailsPopUp,
  // [POPUP_LIST_NAME.WAY_BILL_DETAIL]: WayBillDetailsPopUp,
  // [POPUP_LIST_NAME.CARRIER_DETAIL]: CarrierDetailsPopUp,
  // [POPUP_LIST_NAME.TRANSPORT_DETAIL]: TransportDetailsPopUp,
  [POPUP_LIST_NAME.VIOLATION_DETAIL]: ViolationDetailsPopUp,
  [POPUP_LIST_NAME.VIOLATION_CONTROL_WORK_DETAIL]: ViolationControlWorkDetailsPopUp,
  // [POPUP_LIST_NAME.ORDER_SERVICE_DETAIL]: OrderServiceDetailsPopUp,
  // [POPUP_LIST_NAME.VEHICLE_REGISTRY_POP_UP]: VehicleRegistryPopUp,
  // [POPUP_LIST_NAME.DRIVER_POP_UP]: DriverPopUp,
  // [POPUP_LIST_NAME.VEHICLE_REGISTRY_STATUS_HISTORY_POP_UP]: VehicleRegistryStatusHistoryPopup,
  [POPUP_LIST_NAME.INFORMATION_DETAIL]: InformationPopUp,
  [POPUP_LIST_NAME.REPRESENTATIVE_DETAIL]: RepresentativeDetailsPopUp,
};

export function InformationFormWrapper(props) {
  const dispatch = useDispatch();
  const {
    window = '',
    window2 = '',
    isShow,
    id,
    id2,
  } = useSelector(getGlobalPopUpWrapper);
  const Screen1 = window ? POPUP_LIST[window] : () => {};
  const Screen2 = window2 ? POPUP_LIST[window2] : () => {};
  return (
    isShow ? (
      <div className="global-popup-wrapper">
        <div className="global-popup-wrapper-content">
          <div className="global-popup-wrapper-fade" onClick={() => dispatch((clearGlobalPopUpWrapper({})))} />
          <Screen2 id={id2} />
          <Screen1 id={id} />
        </div>
      </div>
    ) : null
  );
}
